/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthApplicationDto } from '../../models/o-auth-application-dto';
import { UpdateOAuthApplicationCommand } from '../../models/update-o-auth-application-command';

export interface ApiOAuthApplicationsIdPut$Params {
  id: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: UpdateOAuthApplicationCommand
}

export function apiOAuthApplicationsIdPut(http: HttpClient, rootUrl: string, params: ApiOAuthApplicationsIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, apiOAuthApplicationsIdPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OAuthApplicationDto>;
    })
  );
}

apiOAuthApplicationsIdPut.PATH = '/api/OAuthApplications/{id}';
